import * as React from "react";

import * as styles from "src/components/organisms/Advantages/styles.module.scss";
import {Props as CardProps} from "src/components/organisms/ProductCard";
import {Advantages} from "src/components/organisms/Advantages";
import {ProductsGrid} from "src/components/organisms/ProductsGrid";

import {BlockHeading} from "src/components/organisms/BlockHeading";
import { Layout } from "src/components/organisms/Layout";
import { Promo } from "src/components/organisms/Promo";

import circleIcon from 'images/pages/cloud-native-platform/circle.svg';
import arrowsIcon from 'images/pages/cloud-native-platform/arrows.svg';
import diagramIcon from 'images/pages/cloud-native-platform/diagram.svg';

import {products} from "data/cloud-native-platform/data/productsData";
import {moreAbouts} from "data/cloud-native-platform/data/moreAbouts";
import {formItems} from "data/common/formsData";
import {ContactsForm} from "src/components/organisms/ContactsForm";
import {ListBlock, ListTitleSmall, UnorderedList} from "src/components/organisms/ListBlock";
import cls from "classnames";

import listBlock1BGDesktop from 'images/pages/cloud-native-platform/list-block/list-block-1-bg-desktop.png';
import listBlock1BGTablet from 'images/pages/cloud-native-platform/list-block/list-block-1-bg-tablet.png';
import listBlock1BgPhone from 'images/pages/cloud-native-platform/list-block/list-block-1-bg-phone.png';

import { graphql, type HeadFC } from "gatsby";
import type { GatsbyTypes } from "gatsby-types";
import Img from "gatsby-image";
import {gatsbyImagePlaceholderStyle} from "util/commons";

import * as pageStyles from "styles/pages/cloud-native-platform/cloud-native-platform.module.scss";
import {BackgroundImage} from "src/components/organisms/BackgroundImage";
import {StaticImage} from "gatsby-plugin-image";
import {useEffect} from "react";
import {appendLeadInfoScript} from "util/ga/gaHelpers";

type Item = CardProps & { id: number }

export const cards3: Item[]  = [
    {
        id: 1,
        icon: circleIcon,
        title: <>
            Lower TCO&nbsp;<span className="line-break-desktop"><br /></span>
            by&nbsp;<span className="line-break-tablet"><br /></span>up to 20%
        </>,
        description: 'Decrease the number of required Nodes and enable cloud cost saving by using smaller K8S PODs',
        className: styles.card,
        childrenClassNames: {
            title: 'color-white',
            description: 'color-gray',
        },
    },
    {
        id: 2,
        icon: arrowsIcon,
        title: <>Zero&nbsp;<span className="line-break-desktop"><br /></span>migration effort</>,
        description: 'No refactoring is required. Alpaquita is a 100% OpenJDK-based and utilizes Java standard runtime',
        className: styles.card,
        childrenClassNames: {
            title: 'color-white',
            description: 'color-gray',
        },
    },
    {
        id: 3,
        icon: diagramIcon,
        title: <>Increase&nbsp;<span className="line-break-tablet"><br /></span>efficiency&nbsp;<span className="line-break-desktop"><br /></span><span className="line-break-tablet"><br /></span>by up to 50%</>,
        description: 'An adoption of native image tools included in Alpaquita brings low latency, faster startup and lower costs',
        className: styles.card,
        childrenClassNames: {
            title: 'color-white',
            description: 'color-gray',
        },
    }
]

interface Props {
    data: GatsbyTypes.Query
}

const IndexPage: React.FC<Props> = ({ data }) => {
    const description = 'Get all the benefits of cloud-native applications with Java. \n' +
        'Cloud-native Java means faster and lightweight runtimes, reduced complexity ' +
        'and increased stability. By using containers with Java-tuned Linux, JVM optimizations, ' +
        'multi-purpose frameworks, and native image technology you get even more Java advantages.'


    const promoBackground = (className: string) => {
        const sources = [
            {
                ...data.promoDesktopImage.childImageSharp.fluid,
                media: `(min-width: 1024px)`,
            },
            {
                ...data.promoTabletImage.childImageSharp.fluid,
                media: `(min-width: 768px)`,
            },
            data.promoMobileImage.childImageSharp.fluid,
        ]

        return (
            <Img className={className} fluid={sources} placeholderStyle={gatsbyImagePlaceholderStyle} />
        )
    }

    return (
        <Layout button ={{
            className: 'bg-teal color-dark'
        }} forms={data.allFormsJson.nodes}
        >
            <Promo
                className={cls(pageStyles.promo, "bg-black")}
                backgroundElement={promoBackground}
                title="Alpaquita Cloud Native Platform"
                subtitle="The power of Java for cloud-native applications"
                description={description}
                buttons={[
                    {
                        caption: 'Request a Quote',
                        href: "javascript:void(0)",
                        modalId: "#popup-request-alpaquita-cloud-native-platform-quote",
                        className: 'bg-white color-dark'
                    }
                ]}
                childrenClassNames={{
                    content: pageStyles.promoContent
                }}
            />

            <Advantages items={cards3} />

            <ListBlock
                title="What stops Java from becoming the perfect Cloud technology?"
                background={{
                    desktop: listBlock1BGDesktop,
                    tablet: listBlock1BGTablet,
                    phone: listBlock1BgPhone,
                }}
                className={cls(styles.listBlock1, "bg-dark")}
                childrenClassNames={{
                    title: 'color-white'
                }}
                body={(
                    <>
                        <ListTitleSmall className="color-white">To increase their operation efficiency, organizations worldwide move their services to a cloud infrastructure, and so the Cloud business is growing fast.</ListTitleSmall>
                        <p className="color-gray p-2">Java is a proven technology for enterprise-grade applications, known for its security, performance, and competitive costs in the long run. However, Java has been in development since the nineties to serve as a universal tool. As such, despite significant improvements created for the cloud, simply moving Java apps to the cloud infrastructure can lead to several issues, like facing the budget or technical limits.</p>
                        <p className="color-gray p-2">Organizations that went through the process report the overspending over the target cost estimations in more than 50% of cases.</p>
                    </>
                )}
            />

            <ListBlock
                title="Reach for the Cloud with Java - get on Alpaquita!"
                className={cls(styles.listBlock1, "bg-smoke")}
                childrenClassNames={{
                    title: 'color-dark',
                    bgCssStyle: pageStyles.bgCssStyle,
                    body: pageStyles.reachBodyStyle
                }}
                body={(
                    <>
                        <ListTitleSmall className="color-dark">To increase their operation efficiency, organizations worldwide move their services to a cloud infrastructure, and so the Cloud business is growing fast.</ListTitleSmall>
                        <UnorderedList itemClassName="color-gray">
                            <span className="color-gray">The migration is as easy as it gets. Just put your app with dependencies into the container and you are good to go</span>
                            <span className="color-gray">You minimize  the server workload by using the Linux OS fine-tuned for Java and the lightweight performant runtime</span>
                            <span className="color-gray">The native image utility transforms your cloud-native Java containers into executables, providing even more benefits</span>
                        </UnorderedList>
                        <span className="color-gray">Read on for more details.</span>
                    </>
                )}
            />

            <BlockHeading
                className={pageStyles.products}
                text={"What are the components of\n" +
                    "Alpaquita Cloud Native Platform?"}>
                <ProductsGrid
                    columns={2}
                    items={products}
                />
            </BlockHeading>

            <BlockHeading
                headingLevel="2"
                className={pageStyles.moreAbouts}
                bgClassName={pageStyles.background}
                text={"More about Alpaquita Cloud Native Platform"}>
                <ProductsGrid
                    columns={1}
                    items={moreAbouts}
                />
            </BlockHeading>

            <a id="contacts-form"></a>
            <BackgroundImage
                desktop={<StaticImage src={"../../images/pages/cloud-native-platform/form-desktop.png"}
                                      alt={"test"}/>}
                tablet={<StaticImage src={"../../images/pages/cloud-native-platform/form-tablet.png"}
                                     alt={"test"}/>}
                mobile={<StaticImage src={"../../images/pages/cloud-native-platform/form-mobile.png"}
                                     alt={"test"}/>}
                alt={"Contact Form Background"}
            >
                <ContactsForm
                    details="Get guidance on migrating to Alpaquita Cloud Native Platform"
                    title="Speak with an expert to see which solution will serve your business the best"

                    successDetails="Thank you for your interest in our company"
                    successTitle="We will send the guidance on migrating Alpaquita Cloud Native Platform to the specified email"

                    form={formItems}
                />
            </BackgroundImage>

        </Layout>
    )
}

export default IndexPage

export const query = graphql`
query {
    promoMobileImage: file(absolutePath: {regex: "/.*images\\/pages\\/cloud-native-platform\\/promo-mobile.png/"}) {
    childImageSharp {
        fluid(fit: COVER, pngQuality: 90, webpQuality: 90, quality: 90, maxWidth: 1280) {
            ...GatsbyImageSharpFluid,
        }
    }
    }
    promoTabletImage: file(
    absolutePath: {regex: "/.*images\\/pages\\/cloud-native-platform\\/promo-tablet.png/"}
    ) {
    childImageSharp {
        fluid(fit: COVER, pngQuality: 90, webpQuality: 90, quality: 90, maxWidth: 1280) {
            ...GatsbyImageSharpFluid,
        }
    }
    }
    promoDesktopImage: file(
    absolutePath: {regex: "/.*images\\/pages\\/cloud-native-platform\\/promo-desktop.png/"}
    ) {
    childImageSharp {
        fluid(fit: COVER, pngQuality: 90, webpQuality: 90, quality: 90, maxWidth: 1280) {
            ...GatsbyImageSharpFluid,
        }
    }
    }
    
  allFormsJson(filter: {fields: {idSelector: {eq: "popup-request-alpaquita-cloud-native-platform-quote"}}}) {
    nodes {
      title
      details
      successDescription
      successDetails
      successTitle
      formId
      eventAction
      fields {
        hashedIdSelector
        idSelector
      }
      items {
        gridColumn
        name
        placeholder
        required
        type
      }
      controls {
        terms {
          name
        }
        button {
          caption
        }
      }
    }
  }
}
`

export const Head: HeadFC = () =>
    <>
        <title>Cloud Native Platform | BellSoft Java</title>
        <meta name="description" content="Alpaquita Cloud Native Platform is the solution for cloud-native Java apps including lightweight Linux and Java runtime, Java tools, and support." />
    </>
